import { render, staticRenderFns } from "./create-user.vue?vue&type=template&id=38f621e3&scoped=true"
import script from "./create-user.vue?vue&type=script&lang=js"
export * from "./create-user.vue?vue&type=script&lang=js"
import style0 from "./create-user.vue?vue&type=style&index=0&id=38f621e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f621e3",
  null
  
)

export default component.exports